import { atom } from 'jotai';

import { SubscribeModalScreenName } from './types';

import type { Plan } from '@/fixtures/plans';

const subscribeModalOpenAtom = atom(false);

const subscribeModalSelectedPlanAtom = atom<Plan['name'] | null>(null);

const subscribeModalMinimumPlanAtom = atom<Plan['name'] | null>(null);

const subscribeModalInitialScreenOverrideAtom =
  atom<SubscribeModalScreenName | null>(null);

/**
 * Names the feature the visitor was reaching for, so the plan picker can say
 * "Upgrade to unlock <feature>" instead of its generic title (DEV-6610). The
 * value is the highlighted half of the heading — "1080p footage", "WAV audio".
 */
const subscribeModalUnlockFeatureAtom = atom<string | null>(null);

// For tracking if the subscribe modal was opened from a stock video download flow
const subscribeModalIsStockVideoUpsellAtom = atom(false);

// For tracking if the subscription was successful from Stripe / PayPal
const externalSubscriptionSuccessAtom = atom(false);

// Use derived atom to get initial screen
const subscribeModalInitialScreenAtom = atom((get) => {
  const override = get(subscribeModalInitialScreenOverrideAtom);
  if (override) {
    return override;
  }

  const externalSubscriptionSuccess = get(externalSubscriptionSuccessAtom);

  if (externalSubscriptionSuccess) {
    return SubscribeModalScreenName.Safelist;
  }

  return SubscribeModalScreenName.SelectPlan;
});

const openSubscribeModalAtom = atom(null, (_get, set) => {
  set(subscribeModalOpenAtom, true);
});

export {
  externalSubscriptionSuccessAtom,
  openSubscribeModalAtom,
  subscribeModalInitialScreenAtom,
  subscribeModalInitialScreenOverrideAtom,
  subscribeModalIsStockVideoUpsellAtom,
  subscribeModalMinimumPlanAtom,
  subscribeModalOpenAtom,
  subscribeModalSelectedPlanAtom,
  subscribeModalUnlockFeatureAtom,
};
